import { gql } from "urql";
export const GetFilesCountQuery = gql `
    query GetFilesCount(
        $search: String
        $caregiverId: String
        $patientId: String
        $fileTypes: [String]
    ) {
        files {
            fileCount(
                search: $search
                caregiverId: $caregiverId
                patientId: $patientId
                fileTypes: $fileTypes
            )
        }
    }
`;
export const GetFilesQuery = gql `
    query GetFiles(
        $search: String
        $offset: Int
        $caregiverId: String
        $patientId: String
        $fileTypes: [String]
    ) {
        files {
            files(
                search: $search
                offset: $offset
                caregiverId: $caregiverId
                patientId: $patientId
                fileTypes: $fileTypes
            ) {
                fileId
                isOriginatingOrganization
                name
                fileName
                fileType
                fileSize
                mimeType
                tags
                isShared
                createdAt
                originatingOrganization {
                    organizationId
                    name
                }
            }
        }
    }
`;
// Get the caregiver and patient info for uploading a file (used in UploadFileModal.tsx)
export const GetCaregiverAndPatientInfoForFileUploadQuery = gql `
    query GetCaregiverAndPatientInfoForFileUpload($priorityEntryId: String!) {
        priorityEntries {
            priorityEntry(priorityEntryId: $priorityEntryId) {
                priorityEntryId
                caregiverId
                patientId
            }
        }
    }
`;
